module.exports = __webpack_public_path__ + "static/media/rockerbox-performance-icon.e8da5984.svg";